module.exports = __webpack_public_path__ + "static/media/thunders.1fba0ffc.jpg";